<template>
  <button
    type="button"
    v-bind="$attrs"
    class="text-button py-4 px-12 text-white hover:opacity-80 transition-opacity duration-200"
    :class="[variant]"
    :disabled="disabled"
  >
    <busy-area :busy="busy">
      <slot />
    </busy-area>
  </button>
</template>

<script lang="ts" setup>
import BusyArea from '@components/utils/busy/BusyArea.vue';

export type ButtonVariant = 'primary' | 'secondary' | 'outlined' | 'success' | 'text';

defineProps<{ variant: ButtonVariant; busy?: boolean; disabled?: boolean }>();
</script>

<style lang="scss" scoped>
button {
  @apply rounded-4;
  @apply whitespace-nowrap;
  @apply relative;

  &.primary {
    @apply border border-primary bg-primary;
  }
  &.secondary {
    @apply border border-accentuate-text bg-accentuate-text;
  }
  &.outlined {
    @apply bg-none text-current border border-current;
  }
  &.success {
    @apply border border-success-green bg-success-green;
  }
  &.text {
    @apply py-0 px-0 text-current;
  }
}
</style>
